import React from 'react';
import PropTypes from 'prop-types';
import Button from 'components/Button';
import ButtonTypes from 'components/Button/Button.const';

import styles from './DefaultHeaderAuth.styles';
import { isEmpty, toBoolean } from 'util/index';
import ProfilePlaceholderIcon from 'components/svg/ProfilePlaceholder';
import * as cssVariable from 'cssVariables';
import * as cookie from 'util/cookie';
import * as analytics from 'analytics';
import { createUseStyles } from 'react-jss';
import useBrowser from 'components/hooks/useBrowser';
import { breakpoints } from 'components/theme/breakpoints';

const useStyles = createUseStyles(styles, { name: 'DefaultHeaderAuth' });
const DefaultHeaderAuth = ({ register, login, profileDetails, user }) => {
  const classes = useStyles();
  const browser = useBrowser();
  const isLargeScreen = browser.up(breakpoints.ml);

  if (!isEmpty(user) && user.isLoggedIn) {
    // TODO: move to gigya post login/register action
    cookie.setCookie('isUser', 'true');

    const { accountInfo: { profile = {} } = {} } = user;
    const { firstName, lastName, thumbnailURL } = profile;
    let profileButtonText = 'Mijn profiel';
    if (firstName) {
      profileButtonText = lastName ? `${firstName} ${lastName}` : firstName;
    }

    return (
      <button
        type="button"
        className={classes.profileButton}
        data-testid="default-header-profile-btn"
        onClick={profileDetails}
      >
        {thumbnailURL ? (
          <span
            data-testid="default-header-profile-thumbnail"
            className={classes.profileThumb}
            style={{ backgroundImage: `url(${thumbnailURL})` }}
          />
        ) : (
          <ProfilePlaceholderIcon
            data-testid="default-header-profile-thumbnail-placeholder"
            fill={cssVariable.grey100}
            className={classes.placeholder}
          />
        )}
        <span className={classes.profileName}>{profileButtonText}</span>
      </button>
    );
  }

  const onLogin = () => {
    analytics.gigyaExpand('log-in-button');
    // Only one button is visible check if user has been logged in and call login
    // if not call register
    const hasUserCookie = toBoolean(cookie.getCookie('isUser'));
    if (!isLargeScreen && !hasUserCookie) {
      register();
    }
    login();
  };
  const onRegister = () => register();

  return (
    <div className={classes.auth}>
      <Button
        className={classes.authButton}
        data-testid="default-header-login-btn"
        type={ButtonTypes.SECONDARY}
        onClick={onLogin}
        text="Inloggen"
      />
      {isLargeScreen && (
        <Button
          data-testid="default-header-register-btn"
          type={ButtonTypes.PRIMARY}
          onClick={onRegister}
          text="Registreren"
        />
      )}
    </div>
  );
};

DefaultHeaderAuth.propTypes = {
  register: PropTypes.func.isRequired,
  login: PropTypes.func.isRequired,
  profileDetails: PropTypes.func.isRequired,
  user: PropTypes.object,
};

DefaultHeaderAuth.defaultProps = {
  user: null,
};

export default DefaultHeaderAuth;
